import { ViewMode } from '@playbooks/action-cards-utils/src'
import { InputGroup } from '@playbooks/ui/components/input-group'
import { useAppContext } from '../../contexts/AppContext'
import { cn } from '@playbooks/ui/lib/utils'

export default function InputGroupWrapper({ children, className }: { children: React.ReactNode; className?: string }) {
  const {
    settings: { viewMode },
  } = useAppContext()

  const isDocumentView = viewMode === ViewMode.DOC

  return <InputGroup className={cn(isDocumentView ? 'rounded-none' : '', className)}>{children}</InputGroup>
}
